export const PROFESSIONALS_ALERTS = 'PROFESSIONALS'

export function getProfessionals(professionals) {
    return {type: PROFESSIONALS_ALERTS, professionals}
}